<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "Report3D",
        icon: require("@/assets/images/digitalImg/report3d_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/report3d_icon.png"),
          title: "Repotr3D：决策有道，创意先行",
          subTitle: "三维版方案汇报工具，轻松完成三维场景搭建与方案汇报",
          downloadBtnList: [
            {
              label: "下载客户端",
              otherLabel: "下载客户端",
              fileUrl: "",
              fileName: "Report3D",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_report3d.png"),
          videoUrl: `${prefix}/static/video/report3d_cn.mp4`,
        },
        all: {
          title: "什么是 Report3D？",
          content: [
            "Report3D数字化汇报系统，是一款基于游戏引擎研发的、面向多类型工程的汇报工具，实现实时渲染的高效场景创造、PPT的复杂制作功能，使用户能够实时查看和操作数字孪生模型。不需要复杂的安装或配置，降低三维场景使用门槛，让更多的人能够轻松参与三维场景搭建与PPT汇报。",
            "系统以一种三维的、动态的、可交互的汇报方式，探索数字时代成果展示的新模式，以微电影的形式去讲述项目，打造沉浸式体验场景。",
          ],
          imgLists: [
            {
              id: 1,
              title: "多源模型融合：深化三维模型的应用价值（1/3）",
              img: require("@/assets/images/digitalImg/report3d_img1.png"),
            },
            {
              id: 2,
              title: "多源模型融合：深化三维模型的应用价值（2/3）",
              img: require("@/assets/images/digitalImg/report3d_img2.png"),
            },
            {
              id: 3,
              title: "多源模型融合：深化三维模型的应用价值（3/3）",
              img: require("@/assets/images/digitalImg/report3d_img3.png"),
            },
          ],
        },
        highlights: {
          title: "为什么选择 Report3D？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/report3d_icon1.png"),
              title: "高效三维汇报",
              content: "通过三维交互式汇报，真实还原设计场景，提高方案过审率。",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/report3d_icon2.png"),
              title: "交互式设计",
              content:
                "允许在演示中添加互动元素，提高观众参与度，使得演示更加引人入胜。",
            },
            {
              id: 3,
              icon: require("@/assets/images/digitalImg/report3d_icon2.png"),
              title: "多媒体支持",
              content:
                "支持文字、图片、视频、图表等多种媒体元素的插入，丰富演示内容。",
            },
          ],
        },

        function: {
          title: "Report3D 的功能！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/report3d_function01.png"),
              title: "多源数据融合",
              content:
                "持导入Revit、Bently、3DMAX等主流建模软件的模型数据。与狄诺尼自主研发的EICAD、AIRoad数据互通，不仅能导入BIM模型，还能附带路线平纵设计信息。深化三维模型的应用价值，完成数字化汇报的基础场景搭建。",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/report3d_function02.png"),
              title: "大体量倾斜摄影数据的支持",
              content:
                "可流畅加载200G的倾斜摄影模型。内置倾斜摄影透明化处理工具，用户可自定义切割区域，软件自动隐藏区域内倾斜摄影数数据，实现“倾斜切割”。让倾斜摄影与工程模型的无缝融合。",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/report3d_function03.png"),
              title: "内置丰富的模型库与材质库",
              content: [
                "利用模型库功能组，用户通过拖拽、沿线放置模型，快速布置场景，减少用户建模工作量。软件内置材质库功能，用户通过拖拽材质球实现模型材质替换，通过尝试不同材质组合，达到更好的展示效果。",
              ],
            },
            {
              id: 4,
              img: require("@/assets/images/digitalImg/report3d_function04.png"),
              title: "多元标绘方式",
              content:
                "软件内置多种点、线、面三维标绘样式，用户基于汇报的需求，通过多元化的标绘，突出重点、强调关键信息，使设计意图更加易于阐述和理解。三维标绘也支持批量导入CAD标绘数据，大幅提升标绘制作的效率。",
            },
            {
              id: 5,
              img: require("@/assets/images/digitalImg/report3d_function05.png"),
              title: "三维PPT制作",
              content: [
                "软件采用PPT+三维数字化展示的汇报方式，二维编辑功能遵循传统PPT编辑操作习惯。对于已有的PPT汇报文件，用户可以一键导入，再制作汇报的三维展示内容。制作者根据汇报思路，在汇报页面提前设置三维展示的视点与漫游路径并完成挂接，快速完成三维汇报制作。汇报过程中汇报者无需复杂操作，即可完成流畅、连贯与直观的设计表达。",
              ],
            },
          ],
        },
        support: {
          title: "Report3D 的用户支持 ",
          // documnentUrl: "/download?anchor=manual",
          documnentUrl: "/dnnweb/helpDocuments?soft=Report3D&language=zh",
          videosUrl: "/academy?anchor=Report3D",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/report3d_contactbg.png"),
          title: "立即获取Report3D！",
          subTitle: "狄诺尼数字设计软件产品线，为您带来一站式设计解决方案",
          downLoadBtnText: "下载产品手册",
          downLoadBtnUrl: "/download?anchor=manual",
          contactBtnText: "让销售人员联系您",
          contactBtnUrl: "",
        },
        combination: {
          title: "使用其他软件配合 Report3D 进行工作！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/report3d_combination01.png"),
              title: "使用Report3D+AIRoad",
              subTitle: "完成“沪武高速改扩建实施方案汇报",
              content:
                "- 项目使用AIRoad实现路线设计，使用Report3D实现导改场景与车流布置，实时查看导改方案，汇报直观清晰。",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/airoad_icon3.png"),
              desc: "依托自主研发的BIM引擎，基于GIS、航测遥感等数据构建数字化地形，通过动态交互式布线，自动构建方案模型。",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "4" }).then((res) => {
        // console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
